import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { EXCLUSION_STATUS_QUERY } from '../../../graphql.js'
import { Alert, Table, Spinner } from 'reactstrap'
import { handleGraphQLErrors } from '../../../utils.js'
import { FaCheck } from 'react-icons/fa'
import '../Custom.css'

const EXCLUSION_STATUS = gql(EXCLUSION_STATUS_QUERY)

export default function ExclusionStatus() {
  console.log('ExclusionStatus rendered')

  const [results, setResults] = useState([])
  const [graphQLErrors, setGraphQLErrors] = useState([])

  async function getStatus() {
    console.log('ExclusionStatus.getStatus: ')
    try {
      const { data, errors } = await window.apolloClient.query({ query: EXCLUSION_STATUS })
      if (data.exclusionStatus) {
        setResults(data.exclusionStatus)
      }
      if (errors) {
        setGraphQLErrors(errors)
      }
    } catch (err) {
      handleGraphQLErrors(err, setGraphQLErrors)
    }
  }

  useEffect(() => {
    console.log('ExclusionStatus.useEffect')
    const interval = setInterval(() => getStatus(), 5000)
    return () => {
      clearInterval(interval)
    }
  }, [results])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  }

  if (results.length > 0) {
    const rows = []
    for (let i = 0; i < results.length; i++) {
      let row = results[i]
      let statusComponent = row.status
      if (row.status === 'Finished') {
        statusComponent = <FaCheck style={{ color: 'green' }}/>
      }
      if (row.status.includes('Processing')) {
        statusComponent = <><Spinner color="primary" size="sm" /> {row.status}</>
      }
      rows.push(<tr key={i}><td>{row.updated}</td><td style={{ textAlign: 'center'}}>{statusComponent}</td><td>{row.taskName}</td></tr>)
    }

    return (
      <div className="custom-scroll">
        <Table bordered className="custom-table" style={{ marginTop: '20px' }}>
          <thead>
            <tr key={-2}><th colSpan={3} style={{ backgroundColor: 'lightblue', textAlign: 'center' }}>Exclusion Procedure Task Status</th></tr>
            <tr key={-1}>
              <th style={{ backgroundColor: 'lightblue', textAlign: 'center' }}>Updated</th>
              <th style={{ backgroundColor: 'lightblue', textAlign: 'center' }}>Status</th>
              <th style={{ backgroundColor: 'lightblue', textAlign: 'center' }}>Task</th>
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </Table>
      </div>
    )
  } else {
    return <div style={{ textAlign: 'center', marginTop: '50px' }}><h1>Checking exclusion procedure status...</h1></div>
  }
}
